var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{directives:[{name:"sortable",rawName:"v-sortable",value:({
    handler: 'tr',
    callback: _vm.onSorted,
    container: 'tbody'
  }),expression:"{\n    handler: 'tr',\n    callback: onSorted,\n    container: 'tbody'\n  }"}]},[_c('tbody',[_vm._l((_vm.items),function(item){return [(item.children)?[_c('s-table-tree',{attrs:{"items":item.children}})]:_vm._e(),_c('tr',[_c('td',[_vm._v(_vm._s(item.name))])])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }